package com.essntl.features.qbauth.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [QbAuthSupabaseDataSource::class])
internal class QbAuthSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<QbAuthDto> {
    override val tableName: String = "qb_auth"
}
